import { BaseImportStep } from '../base-import-step';

export class AccountTitleStep extends BaseImportStep {
  initialize({
    deps,
  }) {
    super.initialize({
      deps,
    });
    this.currentAccountTitle = this.deps.config.get('CurrentAccount').Title;
    this.summaryTitle = this.i18n.get('GoogleImport_BingAccount_Summary');
    this.currencyTag = this.i18n.get('GoogleImport_AccountCurrencyConversion_CurrencyTag');
  }

  get title() {
    return this.buildTitle({
      summaryTitle: this.summaryTitle,
    }, true);
  }

  getSummaryInfo() {
    let summaryInfo = this.currentAccountTitle;

    summaryInfo = `${summaryInfo} ${this.currencyTag} ${this.deps.config.get('AccountCurrencyCode')}`;
    return summaryInfo;
  }
}
